module.exports = __webpack_public_path__ + "static/media/know-your-story.40d0c989.png";